// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confetti-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 9999;
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.confetti-container.active {
    opacity: 1;
}

.confetti-item {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: confettiFall 3s linear forwards;
    z-index: 10000;
}

.confetti-item img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.9;
    filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.2));
}

@keyframes confettiFall {
    0% {
        transform: translateY(0) rotate(0deg);
        opacity: 1;
    }
    75% {
        opacity: 1;
    }
    100% {
        transform: translateY(100vh) rotate(720deg);
        opacity: 0;
    }
}

/* Add different animation paths for variety */
.confetti-item:nth-child(3n) {
    animation-name: confettiFallSway1;
    animation-duration: 7s;
}

.confetti-item:nth-child(3n+1) {
    animation-name: confettiFallSway2;
    animation-duration: 8s;
}

.confetti-item:nth-child(3n+2) {
    animation-name: confettiFallSway3;
    animation-duration: 9s;
}

@keyframes confettiFallSway1 {
    0% {
        transform: translateY(0) rotate(0deg);
        opacity: 1;
    }
    25% {
        transform: translateY(25vh) translateX(20px) rotate(180deg);
    }
    50% {
        transform: translateY(50vh) translateX(-20px) rotate(360deg);
    }
    75% {
        transform: translateY(75vh) translateX(10px) rotate(540deg);
        opacity: 1;
    }
    100% {
        transform: translateY(100vh) translateX(-10px) rotate(720deg);
        opacity: 0;
    }
}

@keyframes confettiFallSway2 {
    0% {
        transform: translateY(0) rotate(0deg);
        opacity: 1;
    }
    25% {
        transform: translateY(25vh) translateX(-15px) rotate(90deg);
    }
    50% {
        transform: translateY(50vh) translateX(15px) rotate(180deg);
    }
    75% {
        transform: translateY(75vh) translateX(-15px) rotate(270deg);
        opacity: 1;
    }
    100% {
        transform: translateY(100vh) translateX(15px) rotate(360deg);
        opacity: 0;
    }
}

@keyframes confettiFallSway3 {
    0% {
        transform: translateY(0) rotate(0deg);
        opacity: 1;
    }
    25% {
        transform: translateY(25vh) translateX(25px) rotate(-90deg);
    }
    50% {
        transform: translateY(50vh) translateX(-25px) rotate(-180deg);
    }
    75% {
        transform: translateY(75vh) translateX(25px) rotate(-270deg);
        opacity: 1;
    }
    100% {
        transform: translateY(100vh) translateX(-25px) rotate(-360deg);
        opacity: 0;
    }
} `, "",{"version":3,"sources":["webpack://./src/styles/Confetti.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI;QACI,qCAAqC;QACrC,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,2CAA2C;QAC3C,UAAU;IACd;AACJ;;AAEA,8CAA8C;AAC9C;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI;QACI,qCAAqC;QACrC,UAAU;IACd;IACA;QACI,2DAA2D;IAC/D;IACA;QACI,4DAA4D;IAChE;IACA;QACI,2DAA2D;QAC3D,UAAU;IACd;IACA;QACI,6DAA6D;QAC7D,UAAU;IACd;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,UAAU;IACd;IACA;QACI,2DAA2D;IAC/D;IACA;QACI,2DAA2D;IAC/D;IACA;QACI,4DAA4D;QAC5D,UAAU;IACd;IACA;QACI,4DAA4D;QAC5D,UAAU;IACd;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,UAAU;IACd;IACA;QACI,2DAA2D;IAC/D;IACA;QACI,6DAA6D;IACjE;IACA;QACI,4DAA4D;QAC5D,UAAU;IACd;IACA;QACI,8DAA8D;QAC9D,UAAU;IACd;AACJ","sourcesContent":[".confetti-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 9999;\n    overflow: hidden;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.confetti-container.active {\n    opacity: 1;\n}\n\n.confetti-item {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    animation: confettiFall 3s linear forwards;\n    z-index: 10000;\n}\n\n.confetti-item img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    opacity: 0.9;\n    filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.2));\n}\n\n@keyframes confettiFall {\n    0% {\n        transform: translateY(0) rotate(0deg);\n        opacity: 1;\n    }\n    75% {\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(100vh) rotate(720deg);\n        opacity: 0;\n    }\n}\n\n/* Add different animation paths for variety */\n.confetti-item:nth-child(3n) {\n    animation-name: confettiFallSway1;\n    animation-duration: 7s;\n}\n\n.confetti-item:nth-child(3n+1) {\n    animation-name: confettiFallSway2;\n    animation-duration: 8s;\n}\n\n.confetti-item:nth-child(3n+2) {\n    animation-name: confettiFallSway3;\n    animation-duration: 9s;\n}\n\n@keyframes confettiFallSway1 {\n    0% {\n        transform: translateY(0) rotate(0deg);\n        opacity: 1;\n    }\n    25% {\n        transform: translateY(25vh) translateX(20px) rotate(180deg);\n    }\n    50% {\n        transform: translateY(50vh) translateX(-20px) rotate(360deg);\n    }\n    75% {\n        transform: translateY(75vh) translateX(10px) rotate(540deg);\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(100vh) translateX(-10px) rotate(720deg);\n        opacity: 0;\n    }\n}\n\n@keyframes confettiFallSway2 {\n    0% {\n        transform: translateY(0) rotate(0deg);\n        opacity: 1;\n    }\n    25% {\n        transform: translateY(25vh) translateX(-15px) rotate(90deg);\n    }\n    50% {\n        transform: translateY(50vh) translateX(15px) rotate(180deg);\n    }\n    75% {\n        transform: translateY(75vh) translateX(-15px) rotate(270deg);\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(100vh) translateX(15px) rotate(360deg);\n        opacity: 0;\n    }\n}\n\n@keyframes confettiFallSway3 {\n    0% {\n        transform: translateY(0) rotate(0deg);\n        opacity: 1;\n    }\n    25% {\n        transform: translateY(25vh) translateX(25px) rotate(-90deg);\n    }\n    50% {\n        transform: translateY(50vh) translateX(-25px) rotate(-180deg);\n    }\n    75% {\n        transform: translateY(75vh) translateX(25px) rotate(-270deg);\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(100vh) translateX(-25px) rotate(-360deg);\n        opacity: 0;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
